define('webshopFiltersEditView',[
  'module',
  'marionette',
  'underscore',
  'template!webshopFiltersEditView'
], function (
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  // Form shown in a ModalView, for a filter (options.kind = 'filter': names, code, group)
  // or a value ('value': names, code, colour, param). Writes straight into this.model.
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-filters-edit-view',

    ui: {
      name: 'input.name',
      code: 'input.code',
      group: 'select.group',
      hasColor: 'input.has-color',
      color: 'input.color',
      param: 'input.param'
    },

    events: {
      'input @ui.name': 'onNameChange',
      'input @ui.code': 'onCodeChange',
      'change @ui.group': 'onGroupChange',
      'change @ui.hasColor': 'onColorChange',
      'input @ui.color': 'onColorChange',
      'input @ui.param': 'onParamChange'
    },

    initialize: function () {
      this.model.set('names', _.extend({}, this.model.get('names')));
    },

    serializeData: function () {
      var names = this.model.get('names') || {};
      var languages = _.union(this.options.languages || [], _.keys(names));
      var color = this.model.get('color');

      return {
        kind: this.options.kind,
        brandWarning: !!this.options.brandWarning,
        languages: _.map(languages, function (lang) {
          return {lang: lang, name: names[lang] || ''};
        }),
        code: this.model.get('code') || '',
        groupId: this.model.get('groupId') || 'webshop',
        groups: this.options.groups || [],
        hasColor: color !== undefined && color !== null && color >= 0,
        color: (color !== undefined && color !== null && color >= 0) ?
          '#' + ('000000' + parseInt(color, 10).toString(16)).slice(-6) : '#000000',
        param: this.model.get('param') || ''
      };
    },

    onNameChange: function (e) {
      var names = _.extend({}, this.model.get('names'));
      names[$(e.currentTarget).data('lang')] = $(e.currentTarget).val();
      this.model.set('names', names);
    },

    onCodeChange: function () {
      this.model.set('code', this.ui.code.val());
    },

    onGroupChange: function () {
      this.model.set('groupId', this.ui.group.val());
    },

    onColorChange: function () {
      var enabled = this.ui.hasColor.is(':checked');
      this.ui.color.prop('disabled', !enabled);
      this.model.set('color', enabled ? parseInt(this.ui.color.val().substring(1), 16) : -1);
    },

    onParamChange: function () {
      this.model.set('param', this.ui.param.val());
    }
  });
});

